module.exports = __webpack_public_path__ + "img/slider4.17e211bb.gif";